import { useMemo } from 'react';

import { UseBaseTable } from 'hooks/useBaseTable';
import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useQueryProjectScoreCardsSummary } from 'api/queries/getProjectScoreCardsSummary';

import { FilterNames, getFiltersData } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { prepareVersionSelectTitle } from 'components/common/TreeProgramFilter/VersionSelect/versionSelect.utils';

export type UseProjectScorecardsProvider = ReturnType<typeof useProjectScorecardsProvider>;

interface Props {
    componentKey: string;
    widgetId?: string;
    globalFilterData: any;
    localFilters: any;
    table: UseBaseTable['table'];
    endpoints: Record<string, string>;
}

export const useProjectScorecardsProvider = ({ widgetId, globalFilterData, localFilters, endpoints }: Props) => {
    const isInPinboard = Boolean(widgetId);
    const source = isInPinboard ? localFilters : { ...globalFilterData };
    const title = 'My Projects';
    const subTitleForExport = `${title}, ${prepareVersionSelectTitle()}`;

    const filters = useMemo(
        () =>
            getFiltersData({
                [FilterNames.TAG_PORTFOLIO_BOARD]: source?.programTags ?? [],
            }),
        [source],
    );

    const getProjectScoreCardsSummaryPayload = {
        filter: {
            filters,
        },
    };

    const getProjectScoreCardsSummary = useQueryProjectScoreCardsSummary(
        getProjectScoreCardsSummaryPayload,
        endpoints.getProjectScoreCardsSummary,
    );

    // create pill data for PinboardWidgetPills component
    const pillsData = {
        programTags: source?.programTags ?? [],
    };

    const { pillsList: pills } = useGlobalFiltersHook({ source: pillsData, widgetId });

    return {
        ui: {
            state: {
                programTags: source?.programTags ?? [],
            },
            subTitleForExport,
            pills,
            isInPinboard,
        },
        api: {
            getProjectScoreCardsSummary: {
                instance: getProjectScoreCardsSummary,
                payload: getProjectScoreCardsSummaryPayload,
                endpoint: endpoints.getProjectScoreCardsSummary,
            },
        },
    };
};
